import type {TypographyProps} from '@mui/material';

export type Variant = NonNullable<TypographyProps['variant']>;

const VARIANTS = new Set<Variant>([
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'subtitle1', 'subtitle2',
  'body1', 'body2',
  'caption', 'button', 'overline', 'inherit',
]);

export const asVariant = (v: unknown, fallback: Variant): Variant =>
  typeof v === 'string' && VARIANTS.has(v as Variant) ? (v as Variant) : fallback;
